<template>
  <div class="main-container">
    <!-- 查询栏 -->
    <div class="table-nav">
      <DeviceMenu v-model="deviceType" @typeChange="typeChange" class="table-nav-item" />
    </div>
    <div class="table-container">
      <div class="query-nav">
        <el-form ref="queryFormRef" :model="queryForm" label-width="70px">
          <el-row :gutter="24">
            <el-col :span="5">
              <el-form-item prop="seriesName" label="系列名称">
                <el-input v-model.trim="queryForm.seriesName" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item prop="seriesNo" label="系列编码">
                <el-input v-model.trim="queryForm.seriesNo" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="创建时间">
                <el-date-picker
                  style="width: 100%"
                  v-model="dateTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="dateTimeChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" style="margin-right: 6px" @click="handleSearch"
                >搜索</el-button
              >
              <el-button @click="handleReset">重置</el-button>
            </el-col>
            <el-col :span="3">
              <el-button type="primary" style="float: right" @click="handleAddNewType"
                >点击新增</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <div class="table">
        <el-table
          :data="deviceSeriesList"
          ref="deviceTable"
          @sort-change="sortChange"
          v-loading="tableLoading"
          stripe
          border
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            prop="seriesName"
            label="系列名称"
            align="center"
            show-overflow-tooltip
            :resizable="false"
          ></el-table-column>
          <el-table-column
            prop="seriesNo"
            label="系列编码"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="categoryName"
            label="所属设备类型"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="typeName"
            label="所属设备品牌"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="functionCount"
            label="配置参数"
            sortable="custom"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="status" label="协议状态" align="center" :resizable="false">
            <template slot-scope="{ row }">
              <el-switch
                :value="statusType[row.status] ? statusType[row.status].type : false"
                active-color="#67c33a"
                inactive-color="#f56c6c"
                @change="handleStatusChange(row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column width="80px" label="操作" align="center" :resizable="false">
            <template slot-scope="{ row }">
              <el-tooltip class="item" effect="dark" content="修改" placement="top">
                <i class="iconfont iconcaozuo-1xiugai_1" @click="handleEditSeries(row)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页区域 -->
      <div class="page">
        <el-pagination
          :total="total"
          :current-page="queryForm.pageNo"
          :page-size="queryForm.pageSize"
          :page-sizes="[10, 20, 30, 50]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <ValidatPass ref="validatPass" @back="validateBack" />

    <!-- 新增/编辑设备类型对话框 -->
    <AddOrEdit ref="addOrEdit" @back="addOrEditBack" />
  </div>
</template>

<script>
import deviceSeriesApi from 'api/home/device-mangement/device-series';
import validatePassApi from 'api/home/validatePass';
import statusType from '@/config/status';
import DeviceMenu from '../device-components/DeviceMenu';
import ValidatPass from '@/components/PermissionPassword/ValidatPass';
import AddOrEdit from './AddOrEdit';
export default {
  components: {
    DeviceMenu,
    AddOrEdit,
    ValidatPass
  },
  data() {
    return {
      deviceType: '',
      statusType,
      dateTime: '',
      deviceCategoryList: [],
      total: 0,
      queryForm: {
        pageNo: 1,
        pageSize: 10,
        seriesNo: '',
        seriesName: '',
        searchBeginTime: '',
        searchEndTime: ''
      },
      isReset: false,
      sortBy: '',
      sortType: {
        ascending: 'asc',
        descending: 'desc'
      },
      tableLoading: false,
      deviceSeriesList: []
    };
  },
  watch: {
    sortBy: {
      handler: function (newVal) {
        if (this.isReset) {
          return;
        }
        this.getDeviceSeriesListData();
      }
    }
  },
  created() {
    this.getDeviceSeriesListData();
  },
  methods: {
    // 获取设备类型列表
    getDeviceSeriesListData() {
      this.tableLoading = true;
      deviceSeriesApi
        .getDeviceSeriesPage({
          ...this.queryForm,
          sortType: this.sortBy,
          categoryId: this.deviceType
        })
        .then(res => {
          const {
            data: { data, code }
          } = res;
          if (code === 200) {
            const { totalRows, rows } = data;
            this.total = totalRows;
            this.deviceSeriesList = rows;
          }
          this.tableLoading = false;
          this.isReset = false;
          // else {
          //   this.$message.error(res.data.message);
          //   this.tableLoading = false;
          // }
        })
        .catch(err => {
          this.tableLoading = false;
          this.isReset = false;
        });
    },
    // 搜索
    handleSearch() {
      this.queryForm.pageNo = 1;
      this.getDeviceSeriesListData();
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 10;
      this.queryForm.searchBeginTime = '';
      this.queryForm.searchEndTime = '';
      this.dateTime = '';
      this.isReset = true;
      this.deviceType = '';
      this.clearSort();
      this.getDeviceSeriesListData();
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = val;
      this.getDeviceSeriesListData();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getDeviceSeriesListData();
    },
    sortChange({ order }) {
      this.sortBy = order || '';
      this.sortBy && (this.sortBy = this.sortType[order]);
    },
    // 筛选类型改变
    typeChange() {
      if (this.isReset) {
        return;
      }
      this.handleSearch();
    },
    clearSort() {
      this.$refs.deviceTable.clearSort();
      this.sortBy = '';
    },
    // 日期选择
    dateTimeChange(val) {
      if (val) {
        this.queryForm.searchBeginTime = val[0];
        this.queryForm.searchEndTime = val[1];
      } else {
        this.queryForm.searchBeginTime = '';
        this.queryForm.searchEndTime = '';
      }
    },
    handleStatusChange(row) {
      const { status, id } = row;
      if (status == 1) {
        this.tableLoading = true;
        validatePassApi.editDeviceSeriesStatus({ status: 0, id }, '').then(res => {
          if (res.data.code === 200) {
            this.getDeviceSeriesListData();
          }
        });
      } else {
        this.$refs.validatPass.init({ status: 1, id }, 12, true);
      }
    },
    addOrEditBack(type) {
      switch (type) {
        case 0:
          this.handleReset();
          break;
        case 1:
          this.getDeviceSeriesListData();
          break;
      }
    },
    validateBack() {
      this.getDeviceSeriesListData();
    },
    // 点击新增
    handleAddNewType() {
      this.$refs.addOrEdit.init({});
    },
    // 点击修改
    handleEditSeries(row) {
      this.$refs.addOrEdit.init(row);
    }
  }
};
</script>

<style lang="less" scoped>
.main-container {
  padding: 16px;
  .table-container {
    margin-left: 260px;
  }
  .table-nav {
    width: 220px;
    position: absolute;
    height: 100%;
    padding: 16px 0;
    box-sizing: border-box;
    top: 0;
    left: 16px;
    .table-nav-item {
      background-color: #f4f4f4;
      height: 100%;
      overflow-y: auto;
      // &::-webkit-scrollbar {
      //   width: 10px;
      //   height: 1px;
      // }
      // &::-webkit-scrollbar-thumb {
      //   box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      //   background: #535353;
      // }
      // &::-webkit-scrollbar-track {
      //   box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      //   background: #ededed;
      // }
    }
  }
  .query-nav {
    height: 40px;
  }

  .page {
    margin: 16px 0;
    float: right;
  }
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
</style>
